import {
  Component, Input, Output, ContentChild, TemplateRef, EventEmitter
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { SortDir, SelectByFunction } from './data-table.model';

@Component({
  selector: 'sm-dt-column',
  template: '<!-- column: {{ label }} -->',
  standalone: false
})
export class ColumnComponent {
  private sortVal: SortDir = null;
  private sortEmitter = new EventEmitter<SortDir>();

  @Input() label: string;
  @Input() key?: SelectByFunction<any>;
  @Input() dataTest: string;

  @Input() width: number;
  @Input() sortable = false;
  @Input() align: 'left' | 'right' | 'center' = 'left';
  @Input() valign: 'middle' | 'baseline' = 'middle';

  @Input()
  get sort() { return this.sortVal }
  set sort(value: SortDir) {
    if (this.sortVal !== value) {
      this.sortVal = value;
      this.sortEmitter.next(value);
    }
  }

  @Output() sortChange = this.sortEmitter;

  @ContentChild(RouterLink)
    navLink: RouterLink;

  @ContentChild(TemplateRef)
    template: TemplateRef<any>;

  toggleSort() {
    if (this.sort === null) {
      this.sort = 'desc';
    } else if (this.sort === 'desc') {
      this.sort = 'asc';
    } else if (this.sort === 'asc') {
      this.sort = 'desc';
    }
  }
}
